import axios from "axios";
import { toast } from "react-toastify";
import { getAuthToken } from "./auth";

export const STATUS_FILTERS = {
    status_id: "",
    status_name: "",
    status_code: "",
    is_active: true,
    order_no: ""
};

export const PRIORITY_FILTERS = {
    priority_name: "",
    priority_code: "",
    is_active: true
}

export const CATEGORY_FILTERS = {
    category_id: "",
    category_name: "",
    category_belongs_to: "",
    is_active: true,
    type_code: "",
}

export const DASHBOARD_SUMMARY_FILTERS = {
    status_code: "",
    priority_code: "",
    updated_from: "",
    updated_to: ""
}

export const TASK_STATUS_MAP = {
    PENDING: ['BACKLOG', 'TODO', 'IN_PROGRESS'],
    UNDER_REVIEW: ['REVIEW'],
    ON_HOLD: ['ON_HOLD'],
    COMPLETED: ['COMPLETED'],
    APPROVED: ['APPROVED'],
    REJECTED: ['REJECTED'],
};

export const getTabsFromSubtasks = (subTasks = []) => {
    const map = new Map();

    subTasks.forEach((st) => {
        const { type_code, type_name, order_no } = st.task_type;
        if (!map.has(type_code)) {
            map.set(type_code, {
                code: type_code,
                label: type_name.replace(' Verification', ''),
                order: order_no,
            });
        }
    });

    return Array.from(map.values()).sort((a, b) => a.order - b.order);
};

// QMS Tab — Query Visibility Across RO, BM and BCM: groups a task's sub-tasks by the
// assignee's designation, so the Admin Panel can show a per-officer tab (RO / BM / BCM)
// alongside the existing per-type tabs, matching the PRD's "My Designation / RO / BM /
// BCM / All" segmented control. Only designations that actually have a sub-task on this
// task are returned, in a fixed RO -> BM -> BCM order so the control doesn't reorder
// itself per task.
const DESIGNATION_ORDER = ["RO", "BM", "BCM"];

export const getDesignationTabsFromSubtasks = (subTasks = []) => {
    const present = new Set(
        subTasks
            .map((st) => st.assignee?.designation?.toUpperCase())
            .filter((code) => DESIGNATION_ORDER.includes(code))
    );

    return DESIGNATION_ORDER.filter((code) => present.has(code));
};

export const getStatusCounts = (subTasks = []) => {
    let pending = 0;
    let underReview = 0;
    let onHold = 0;
    let approved = 0;
    let rejected = 0;

    subTasks.forEach((st) => {
        const code = st.status?.status_code;

        if (TASK_STATUS_MAP.PENDING.includes(code)) pending++;
        if (TASK_STATUS_MAP.UNDER_REVIEW.includes(code)) underReview++;
        if (TASK_STATUS_MAP.ON_HOLD.includes(code)) onHold++;
        else if (TASK_STATUS_MAP.COMPLETED.includes(code)) approved++;
        else if (TASK_STATUS_MAP.REJECTED.includes(code)) rejected++;
    });

    return { pending, approved, rejected, onHold, underReview };
};

export const getSubtaskCountByType = (subTasks = []) => {
    console.log({ subTasks });
  return subTasks.reduce((acc, subTask) => {
    // const typeCode = subTask.task_type.type_code;
    const typeId = subTask.task_type.type_id;

    acc[typeId] = (acc[typeId] || 0) + 1;

    return acc;
  }, {
    "1": 0,
    "2": 0
  });
};

export const getViewTaskDocumentUrl = async (doc) => {
    // let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    // let authToken = tokens?.token || null;
    let authToken = getAuthToken();

    if (!authToken) {
        return;
    }

    const headers = {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'application/json'
    };

    try{
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/task/task-documents/view/${doc.document_id}`,
        { headers });

        const viewUrl = res?.data?.data?.data;

        return {
            ...doc,
            document_url: viewUrl,
        };

    }
    catch(err){
        const status = err?.response?.data?.statusCode;
        const serverMessage = err?.response?.data?.message;

        let toastMessage = "Something went wrong.";

        if (status === 404) {
            toastMessage = serverMessage || "Document not found.";
        } else if (status === 500) {
            toastMessage = serverMessage || "Internal server error.";
        } else if (serverMessage) {
            toastMessage = serverMessage;
        }

        toast.error(`${toastMessage}`);
        return null;
    }
}

export const getAllComments = async (filters) => {
    // let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    // let authToken = tokens?.token || null;
    let authToken = getAuthToken();

     if (!authToken) {
      toast.error(`Invalid or missing token.`);
      return;
    }

    let headers = {
      'Authorization': `Bearer ${authToken}`,
      'Content-Type': 'application/json'
    }

    let queryParams = new URLSearchParams();

    if(filters.task_id){
      queryParams.append("task_id", filters.task_id);
    }
    if(filters.sub_task_id){
      queryParams.append("sub_task_id", filters.sub_task_id);
    }
    if(filters.comment_text){
      queryParams.append("comment_text", filters.sub_task_id);
    }

    try {
      let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/task/get-all-comments?${queryParams.toString()}`, { headers });

      if(response?.data?.data){
        return response?.data?.data?.comments;
      }
    }
    catch (error) {
        let errorMsg = error?.response?.data?.message;
        toast.error(`${errorMsg}`);
        return [];
    }
  }


// module.exports = {
//     STATUS_FILTERS,
//     PRIORITY_FILTERS,
//     CATEGORY_FILTERS,
//     DASHBOARD_SUMMARY_FILTERS,
//     TASK_STATUS_MAP,
//     getTabsFromSubtasks,
//     getStatusCounts,
//     getSubtaskCountByType,
//     getViewTaskDocumentUrl
// }